(function () {
'use strict';
var VL = window.VL; if (!VL) return;
var h = VL.h;
function lat1(s) { return String(s).replace(/[^\u0000-ÿ–—‘’“”•…€]/g, function (ch) { return ch.normalize('NFD').replace(/[̀-ͯ]/g, ''); }); }

var OPTS = [
  { v: 0, t: 'Casi siempre' },
  { v: 1, t: 'A veces' },
  { v: 2, t: 'Pocas veces' }
];
var LEVEL = ['Va bien', 'Mejorable', 'Prioridad'];

// m: fichas de la biblioteca (vbt-0xx); x: otros módulos de VedicLife
var AREAS = [
  { k: 'descanso', n: 'Descanso y sueño', q: 'Duermo lo suficiente y me levanto descansado.',
    obs: ['Mantén una hora parecida para acostarte y levantarte, también el fin de semana.', 'Deja las pantallas unos 30 minutos antes de dormir.', 'Un dormitorio oscuro, fresco y silencioso suele ayudar.'],
    trad: 'El Ayurveda cuenta el sueño (nidrā) entre los tres pilares de la vida, junto a la alimentación y una conducta moderada.',
    int: 'Desde ShivaRam lo relacionamos con las prácticas de transición hacia el sueño de la biblioteca.',
    m: ['vbt-009', 'vbt-002'], x: [],
    care: 'Si los problemas de sueño duran semanas o afectan a tu día a día, consulta a un profesional sanitario.' },
  { k: 'tension', n: 'Tensión y estrés del día', q: 'Termino el día sin sentirme tenso ni desbordado.',
    obs: ['Haz pausas breves cada hora u hora y media: levántate, estira, mira lejos.', 'Anota las tareas pendientes antes de terminar el día para no llevarlas en la cabeza.', 'Un paseo corto al aire libre es una forma sencilla de cambiar de ritmo.'],
    trad: 'Patañjali define el yoga como el aquietamiento de los movimientos de la mente (Yoga Sūtra I.2).',
    int: 'Lo relacionamos con prácticas breves de respiración y quietud que caben en una pausa.',
    m: ['vbt-001', 'vbt-017'], x: [],
    care: 'Si la tensión o la ansiedad son intensas o constantes, busca el apoyo de un profesional de la salud.' },
  { k: 'respiracion', n: 'Respiración', q: 'Noto que respiro con calma y sin prisa durante el día.',
    obs: ['De vez en cuando, comprueba si estás conteniendo el aire o respirando solo con el pecho.', 'Respira por la nariz cuando sea cómodo.', 'Tres respiraciones atentas antes de una tarea difícil ayudan a cambiar de ritmo.'],
    trad: 'En el yoga, prāṇa es la energía vital asociada a la respiración, y prāṇāyāma es su regulación (Yoga Sūtra II.49).',
    int: 'Aquí solo proponemos observar la respiración natural, sin retenciones ni técnicas avanzadas.',
    m: ['vbt-001', 'vbt-002'], x: [],
    care: 'Si notas falta de aire, dolor en el pecho o mareos, consulta a un médico.' },
  { k: 'luz', n: 'Luz natural', q: 'Paso tiempo con luz natural, en casa o fuera.',
    obs: ['Abre cortinas y persianas por la mañana.', 'Coloca tu mesa de trabajo o lectura cerca de una ventana.', 'Sal al exterior unos minutos durante el día, aunque esté nublado.'],
    trad: 'La tradición Vastu suele valorar la entrada de luz por el este, la dirección del sol de la mañana.',
    int: 'Lo relacionamos con el informe Vastu de tu vivienda y con prácticas de atención al espacio y la luz.',
    m: ['vbt-005', 'vbt-015'], x: ['vastu'],
    care: '' },
  { k: 'aire', n: 'Ventilación y aire', q: 'Ventilo mi casa cada día y el aire se nota fresco.',
    obs: ['Abre las ventanas unos minutos al día, mejor creando corriente.', 'Ventila después de cocinar, ducharte o usar productos de limpieza.', 'Si quemas incienso o velas, hazlo con una ventana entreabierta.'],
    trad: 'En Vastu, el aire (vāyu) es uno de los cinco elementos (pañca mahābhūta) y se suele asociar al noroeste.',
    int: 'Lo relacionamos con el análisis de estancias de Vastu.',
    m: ['vbt-002'], x: ['vastu'],
    care: '' },
  { k: 'ruido', n: 'Ruido y silencio', q: 'Tengo momentos de silencio a lo largo del día.',
    obs: ['Reserva unos minutos al día sin música, vídeos ni notificaciones.', 'Silencia las notificaciones que no son urgentes.', 'Alfombras, cortinas y cojines reducen el eco de una habitación.'],
    trad: 'Las tradiciones contemplativas de la India valoran el silencio (mauna) como práctica.',
    int: 'Lo relacionamos con las prácticas de escucha y silencio de la biblioteca.',
    m: ['vbt-004', 'vbt-003'], x: [],
    care: '' },
  { k: 'orden', n: 'Orden y comodidad del espacio', q: 'Mi casa está ordenada y me siento cómodo en ella.',
    obs: ['Empieza por una sola superficie: la mesa, la mesilla o la entrada.', 'Deja libres las zonas de paso.', 'Elige un rincón tranquilo para sentarte unos minutos al día.'],
    trad: 'Vastu propone mantener despejado el centro de la vivienda (brahmasthāna).',
    int: 'Lo relacionamos con el informe Vastu y con prácticas de atención al espacio.',
    m: ['vbt-016', 'vbt-014'], x: ['vastu'],
    care: '' },
  { k: 'relaciones', n: 'Relaciones y conversación', q: 'Tengo conversaciones tranquilas con las personas cercanas.',
    obs: ['Dedica un rato a hablar sin el móvil delante.', 'Antes de responder en un momento tenso, haz una pausa de tres respiraciones.', 'Recuerda algún momento compartido que te hizo bien.'],
    trad: 'Los Yoga Sūtra (I.33) recomiendan cultivar amistad, compasión, alegría y ecuanimidad según la situación.',
    int: 'Lo relacionamos con las prácticas de la biblioteca sobre emociones.',
    m: ['vbt-007', 'vbt-018'], x: [],
    care: 'Si una relación te hace daño o te sientes en peligro, pide ayuda a una persona de confianza o a los servicios de apoyo de tu zona.' },
  { k: 'habitos', n: 'Hábitos diarios', q: 'Tengo horarios regulares para comer, moverme y descansar.',
    obs: ['Come sentado y sin pantallas al menos una vez al día.', 'Incluye algo de movimiento suave cada día, como caminar.', 'Intenta mantener horarios parecidos de un día a otro.'],
    trad: 'El Ayurveda da importancia a la rutina diaria (dinacaryā): horarios regulares para levantarse, comer y dormir.',
    int: 'Lo relacionamos con las recetas y el planificador de Supa Shastra y con el calendario de Kaala.',
    m: ['vbt-008'], x: ['supa', 'kaala'],
    care: '' }
];
var MODS = {
  vastu: { n: 'Vastu Shastra', p: '/pages/vastu-shastra' },
  kaala: { n: 'Kaala Nirnaya', p: '/pages/kaala-nirnaya-shastra' },
  supa: { n: 'Supa Shastra · Ayurveda', p: '/pages/supa-shastra-ayurveda' }
};
var INTRO = 'Un repaso breve de nueve aspectos de tu día a día y de tu casa. Recibirás sugerencias prácticas y prácticas de la biblioteca relacionadas. Tus respuestas no salen de este navegador.';
var LIMITS = 'Esta herramienta no mide energías, aura ni «energía negativa», y no diagnostica ninguna enfermedad. Cada sugerencia separa lo que dice la tradición, la interpretación de ShivaRam y lo que puedes observar por ti mismo. No sustituye la atención médica ni psicológica.';

function today() { var d = new Date(); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }

VL.register('equilibrio', {
mount: function (mount, ctx) {
var root = ctx.root, c = ctx.c;
var base = (root.getAttribute('data-vl-base') || '');
var titles = {};
if (window.VLD && VLD.medita) VLD.medita.items.forEach(function (it) { titles[it.id] = it.title; });
var ans = {};

function medLink(id) { return h('a', { href: base + '/pages/meditaciones#' + id, text: titles[id] ? 'Meditación: ' + titles[id] : 'Ficha ' + id }); }

function form() {
  VL.clear(mount);
  mount.appendChild(h('div', { class: 'vl-panel' }, h('p', { class: 'vl-lead', text: INTRO }), h('p', { class: 'vl-note', text: LIMITS })));
  var f = h('form', { class: 'vl-panel', novalidate: 'novalidate', onsubmit: function (e) { e.preventDefault(); submit(); } });
  AREAS.forEach(function (a, i) {
    var fs = h('fieldset', { class: 'vl-field' }, h('legend', { text: (i + 1) + '. ' + a.n + ': ' + a.q }));
    var row = h('div', { class: 'vl-row' });
    OPTS.forEach(function (o) {
      var id = VL.uid('eq');
      var inp = h('input', { type: 'radio', name: 'eq-' + a.k, id: id, value: String(o.v), onchange: function () { ans[a.k] = o.v; } });
      if (ans[a.k] === o.v) inp.checked = true;
      row.appendChild(h('label', { for: id, class: 'vl-choice' }, inp, ' ' + o.t));
    });
    fs.appendChild(row);
    f.appendChild(fs);
  });
  var err = h('p', { class: 'vl-alert vl-alert--info', hidden: 'hidden', 'aria-live': 'polite' });
  f.appendChild(err);
  f.appendChild(h('div', { class: 'vl-actions' }, h('button', { type: 'submit', class: 'vl-btn', text: 'Ver mis sugerencias' })));
  mount.appendChild(f);
  function submit() {
    var miss = AREAS.filter(function (a) { return ans[a.k] === undefined; });
    if (miss.length) { err.hidden = false; err.textContent = 'Falta responder: ' + miss.map(function (a) { return a.n; }).join(', ') + '.'; return; }
    result();
  }
}

function areaCard(a) {
  var lv = ans[a.k];
  return h('article', { class: 'vl-x' },
    h('div', { class: 'vl-x__head' }, h('h3', { class: 'vl-x__title', text: a.n }), h('span', { class: 'vl-tag ' + (lv === 0 ? 'vl-tag--ok' : 'vl-tag--na'), text: LEVEL[lv] })),
    h('p', { class: 'vl-note', text: 'Tu respuesta: ' + OPTS[lv].t.toLowerCase() + ' · «' + a.q + '»' }),
    h('h4', { text: 'Lo que puedes observar y probar' }),
    h('ul', null, a.obs.map(function (s) { return h('li', { text: s }); })),
    h('h4', { text: 'Qué dice la tradición' }), h('p', { text: a.trad }),
    h('h4', { text: 'Interpretación de ShivaRam' }), h('p', { text: a.int }),
    h('ul', null, a.m.map(function (id) { return h('li', null, medLink(id)); }).concat(a.x.map(function (k) { return h('li', null, h('a', { href: base + MODS[k].p, text: MODS[k].n + ' (con tu cuenta gratuita)' })); }))),
    a.care ? h('p', { class: 'vl-alert vl-alert--info', text: a.care }) : null);
}

function result() {
  VL.clear(mount);
  var order = AREAS.slice().sort(function (x, y) { return ans[y.k] - ans[x.k]; });
  var focus = order.filter(function (a) { return ans[a.k] > 0; }).slice(0, 3);
  var top = h('div', { class: 'vl-panel' },
    h('h2', { tabindex: '-1', text: 'Tus sugerencias' }),
    focus.length
      ? h('p', { class: 'vl-lead', text: 'Por dónde empezar: ' + focus.map(function (a) { return a.n.toLowerCase(); }).join(', ') + '. Elige solo una cosa para esta semana.' })
      : h('p', { class: 'vl-lead', text: 'Todas tus respuestas son «casi siempre». Puedes repasar las sugerencias o volver a hacer el repaso más adelante.' }),
    h('p', { class: 'vl-note', text: LIMITS }));
  var saved = h('p', { class: 'vl-note', 'aria-live': 'polite' });
  top.appendChild(h('div', { class: 'vl-actions' },
    h('button', { type: 'button', class: 'vl-btn vl-btn--sm', onclick: pdf, text: 'Descargar PDF' }),
    h('button', { type: 'button', class: 'vl-btn vl-btn--ghost vl-btn--sm', onclick: function () {
      var list = VL.store.get('equilibrio-res', []) || [];
      var r = {}; AREAS.forEach(function (a) { r[a.k] = ans[a.k]; });
      list.push({ d: today(), r: r }); VL.store.set('equilibrio-res', list.slice(-24));
      saved.textContent = 'Guardado en «Mi camino», solo en este navegador.'; VL.announce(root, 'Resultado guardado', 'ok');
    }, text: 'Guardar en Mi camino' }),
    h('button', { type: 'button', class: 'vl-btn vl-btn--ghost vl-btn--sm', onclick: form, text: 'Cambiar respuestas' })));
  top.appendChild(saved);
  mount.appendChild(top);
  var grid = h('div', { class: 'vl-xlist' });
  order.forEach(function (a) { grid.appendChild(areaCard(a)); });
  mount.appendChild(grid);
  var hd = top.querySelector('h2'); if (hd && hd.focus) hd.focus();
}

function pdf() {
  try {
    var pc = VL.translator(VL.COMMON, 'es');
    var doc = new VL.PDFDoc({ title: 'Equilibrio personal y ambiental', footer: pc('disclaimerShort'), pageLabel: pc('page') });
    var txt0 = doc.txt; doc.txt = function (x, y, s, size, bold, rgb) { return txt0.call(this, x, y, lat1(s), size, bold, rgb); };
    doc.h1('Equilibrio personal y ambiental');
    doc.p(pc('generated', { date: VL.fmtDate(new Date(), 'es') }), { size: 9.5, rgb: '0.35 0.38 0.45' });
    doc.box(LIMITS);
    AREAS.slice().sort(function (x, y) { return ans[y.k] - ans[x.k]; }).forEach(function (a) {
      doc.h2(a.n + ' · ' + LEVEL[ans[a.k]]);
      doc.p('Tu respuesta: ' + OPTS[ans[a.k]].t.toLowerCase() + ' («' + a.q + '»)', { size: 9.5, rgb: '0.35 0.38 0.45' });
      doc.bullets(a.obs);
      doc.p('Tradición: ' + a.trad, { size: 9.5 });
      doc.p('Interpretación de ShivaRam: ' + a.int, { size: 9.5 });
      var rel = a.m.map(function (id) { return 'Meditación: ' + (titles[id] || id); }).concat(a.x.map(function (k) { return MODS[k].n; }));
      if (rel.length) doc.p('Relacionado: ' + rel.join(' · '), { size: 9.5 });
      if (a.care) doc.box(a.care);
    });
    VL.downloadPDF(doc, 'equilibrio-' + today() + '.pdf');
    VL.announce(root, c('pdfOk'), 'ok');
  } catch (e) { if (window.console) console.error(e); VL.announce(root, c('pdfFail'), 'error'); }
}

form();
}
});
VL.EQ_AREAS = AREAS; VL.EQ_LEVEL = LEVEL;
if (VL.boot) VL.boot();
})();
